var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-4 pa-sm-8",attrs:{"fluid":""}},[_c('h2',{staticClass:"dark--text text-h5 font-weight-bold mt-3 mt-sm-0"},[_vm._v(" Profile Settings ")]),_c('app-preference-form')],1)}
var staticRenderFns = []

export { render, staticRenderFns }